<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue code="pi_anonyme" v-model="sasSignalementPi.desireSIdentifier" :live="liveSasSignalementPi(16535)"></opq-catalogue>

    <opq-catalogue
      :opq-if="nEstPasAnonyme"
      code="pi_confidentielsignalant"
      v-model="sasSignalementPi.confidentiel"
      :live="liveSasSignalementPi(16524)"
    ></opq-catalogue>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_nomsignalant"
      v-model="sasSignalementPi.nomSignalant"
      :live="liveSasSignalementPi(16519)"
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_prenomsignalant"
      v-model="sasSignalementPi.prenomSignalant"
      :live="liveSasSignalementPi(16518)"
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_adressesignalant"
      v-model="sasSignalementPi.adresseSignalant"
      :live="liveSasSignalementPi(16520)"
      :id="'adresseSignalant'"
      ref="adresseSignalant"
      optional
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_complementadressesignalant"
      v-model="sasSignalementPi.complementDAdresseSignalant"
      :live="liveSasSignalementPi(16530)"
      ref="complementDAdresseSignalant"
      optional
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_cpsignalant"
      v-model="sasSignalementPi.codePostalSignalant"
      :live="liveSasSignalementPi(16532)"
      is-code-postal
      :code-pays="codePays(sasSignalementPi.paysSignalant)"
      ref="codePostalSignalant"
      optional
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_villesignalant"
      v-model="sasSignalementPi.villeSignalant"
      :live="liveSasSignalementPi(16531)"
      ref="villeSignalant"
      optional
    ></opq-text-field>

    <opq-catalogue
      :opq-if="nEstPasAnonyme && paysEstUSouCA(sasSignalementPi.paysSignalant)"
      code="pi_provincesignalant"
      v-model="sasSignalementPi.provinceSignalant"
      :live="liveSasSignalementPi(16533)"
      :parent="sasSignalementPi.paysSignalant"
      order-by="text"
      ref="provinceSignalant"
      optional
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="nEstPasAnonyme"
      code="pi_payssignalant"
      v-model="sasSignalementPi.paysSignalant"
      :live="liveSasSignalementPi(16534)"
      ref="paysSignalant"
      order-by="text"
      optional
    ></opq-catalogue>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_telephonesignalant"
      v-model="sasSignalementPi.telephoneSignalant"
      :live="liveSasSignalementPi(16521)"
      is-phone-number
      :code-pays="codePays(sasSignalementPi.paysSignalant)"
      optional
    ></opq-text-field>

    <opq-text-field
      :opq-if="nEstPasAnonyme"
      code="pi_courrielsignalant"
      v-model="sasSignalementPi.courrielSignalant"
      :live="liveSasSignalementPi(16522)"
      is-email
      optional
    ></opq-text-field>

    <opq-catalogue
      :opq-if="nEstPasAnonyme"
      code="pi_membreautreordresignalant"
      v-model="sasSignalementPi.membreAutreOrdreSignalant"
      :live="liveSasSignalementPi(16523)"
      multiple
      orderBy="text"
      optional
      width="500"
    ></opq-catalogue>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [FormSimple, CataloguesHelper, PosteCanada],
  props: {
    sas: { type: Object }
  },

  data: () => ({
    posteCanadaMainconfig: {
      searchFieldId: "adresseSignalant",
      adresseKey: "adresseSignalant",
      completementDAdresseKey: "complementDAdresseSignalant",
      villeKey: "villeSignalant",
      codePostalKey: "codePostalSignalant",
      provinceKey: "provinceSignalant",
      paysKey: "paysSignalant"
    }
  }),

  computed: {
    sasSignalementPi() {
      return this.sas.sasSignalementPratiqueIllegale
    },

    nEstPasAnonyme() {
      return this.estOui(this.sasSignalementPi.desireSIdentifier)
    }
  },

  methods: {
    liveSasSignalementPi(cle) {
      return { endpoint: "/sas-signalement-pratique-illegale/", cle: cle, fileId: this.sasSignalementPi.id }
    }
  }
}
</script>

<style>
</style>